


















import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { ListMixin } from '@/mixins/list.mixin'
import { Column } from 'ant-design-vue/types/table/column'

@Component
export default class ManagersView extends mixins(ListMixin) implements ListMixin {
  apiConfig = {
    path: 'managers'
  }

  columns: Partial<Column>[] = [
    {
      dataIndex: 'name',
      title: 'Имя',
      scopedSlots: {
        customRender: 'name'
      }
    },
    {
      dataIndex: 'email',
      title: 'Email'
    }
  ]

  syncInProgress = false

  async changeActive(item: any, active) {
    await this.$api.patch(`${this.apiConfig.path}/${item.id}`, { active })
    await this.$message.success('Сохранено')
  }

  async sync() {
    try {
      this.syncInProgress = true
      await this.$api.post(`${this.apiConfig.path}/sync`)
      await this.fetch()
      await this.$message.success('Синхронизировано')
    } finally {
      this.syncInProgress = false
    }
  }
}
